export const DC_ORIGIN_COLUMN_LIST = [
  `name`,
  `addressLine`,
  `houseNumber`,
  `addressExtension`,
  `city`,
  `postalCode`,
  `country`,
  `countryCode`
];

export const DC_RESULT_COLUMN_LIST = DC_ORIGIN_COLUMN_LIST;
